import './landingPage.scss';

import React, {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {fetchFacets, search} from '../search/duck/search-actions';
import {SearchBar} from '../search/search-bar/searchBar';
import {useNavigate} from 'react-router-dom';
import {clearAllSelectedFilters} from '../facets/duck/filter.actions';
import {useAreFiltersPersistent} from '../facets/duck/filter.hooks';

export const LandingPage = React.memo(() => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const isPersistent: boolean = useAreFiltersPersistent();

    const triggerSearch = useCallback((searchExpression: string) => {
        const comingFromLandingPage = (to: any, options?: any) => {
            return navigate(to, {
                ...options,
                state: {...(options?.state ?? {}), comingFromLandingPage: true},
            });
        };

        if (!isPersistent) {
            dispatch(clearAllSelectedFilters());
        }
        dispatch(search(comingFromLandingPage, searchExpression));
        dispatch(fetchFacets(searchExpression));
        // dependencies stay constant, avoid unnecessary re-renders
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const bgImageUrl: string = process.env.PUBLIC_URL + '/images/landing.jpg';
    const bgColor1: string = getComputedStyle(document.documentElement).getPropertyValue('--hibuGradientColor1');
    const bgColor2: string = getComputedStyle(document.documentElement).getPropertyValue('--hibuGradientColor2');
    const bgColor3: string = getComputedStyle(document.documentElement).getPropertyValue('--hibuGradientColor3');

    return (
        <div id={'landing-page'}>
            <div id="gradient-background" style={{
                backgroundImage: `linear-gradient(130deg, ${bgColor1} 0%, ${bgColor2} 64%, ${bgColor3} 100%), url('${bgImageUrl}')`
            }}/>
            <SearchBar
                placeholder={'search.label.placeholder'}
                onSubmit={triggerSearch}
                initialValue={String('')}
            />
        </div>
    );
});
